import { WprValueMap } from '../../../wpr-framework/model/WprValueMap';
import { WprValueMapSetter } from '../../../wpr-framework/model/WprValueMapSetter';

/**
 * クレジットカード有効期限バリューマップ
 */
export class CreditExpireValueMap {
	// static メソッド  --------------------------------------------------------
	public static addValueMap(vmSetter: WprValueMapSetter): void {
		let vm = new WprValueMap();
		vm.addValue('01', '01');
		vm.addValue('02', '02');
		vm.addValue('03', '03');
		vm.addValue('04', '04');
		vm.addValue('05', '05');
		vm.addValue('06', '06');
		vm.addValue('07', '07');
		vm.addValue('08', '08');
		vm.addValue('09', '09');
		vm.addValue('10', '10');
		vm.addValue('11', '11');
		vm.addValue('12', '12');
		vmSetter.addValueMap('cc-exp-month', vm);

		// vm = new WprValueMap();
		// vm.addValue(1, '20');
		// vm.addValue(2, '21');
		// vm.addValue(3, '22');
		// vm.addValue(4, '23');
		// vm.addValue(5, '24');
		// vm.addValue(6, '25');
		// vm.addValue(7, '26');
		// vm.addValue(8, '27');
		// vm.addValue(9, '28');
		// vm.addValue(10, '29');
		// vm.addValue(11, '30');
		// vm.addValue(12, '31');
		// vmSetter.addValueMap('cc-exp-year', vm);
	}
}